<template>
  <div class="test-container">
    <el-input v-model="url" placeholder="请输入路由" />
    <p></p>
    <el-input v-model="name" placeholder="请输入标识" />
    <p></p>
    <el-button @click="_submit">页面可访问权限存入数据库</el-button>
    <p></p>
    <div class="div">Home</div>
    <router-link to="/">Home</router-link>
    <router-link to="/test">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
    <router-link to="/test1">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
    <router-link to="/test2">
      <img style="width:200px" src="../../common/images/c.jpg" />
    </router-link>
  </div>
</template>

<script type="text/ecmascript-6">
import {
  getAllNews,
  addComment,
  getCommentByAid
} from "../../common/js/api.js";
import { tool } from "../../common/js/tool.js";
import TestComponent from "../../components/test/test.vue";
import ElButton from "../../../node_modules/element-ui/packages/button/src/button";
import ElInput from "../../../node_modules/element-ui/packages/input/src/input";
export default {
  data() {
    return {
      url: "",
      name: ""
    };
  },

  computed: {},

  created() {},

  methods: {
    _submit() {
      let tmpArray = [];
      let a = tool.getCookie("urls");
      if (a) {
        console.log(JSON.parse(a));
        tmpArray = JSON.parse(a);
      } else {
        //alert('还没有数据');
      }
      tmpArray.push(this.name);
      tool.setCookie("urls", JSON.stringify(tmpArray));
    }
  },

  components: {
    ElInput,
    ElButton,
    "v-test": TestComponent
  }
};
</script>

<style lang="less" rel="stylesheet/less" scoped="true">
@import url("../../common/less/variable.less");

.test-container {
  width: 100%;
  height: 100%;
  background: white;
}
</style>
